/* Songbond quiz engine for the storefront.
 * Compiled from the APP, unchanged: lib/preview/quiz2.ts + app/_white/quiz/data.ts.
 * Same rules, same words, types removed. Never hand-edit — recompile from the app.
 */
(function(){
const QUIZ2_STORAGE_KEY = "songbond_preview_session";
const REL_CHIPS = [
    "Daughter", "Husband", "Granddaughter", "Wife",
    "Son", "Friend", "Grandson", "Sister",
    "Brother", "Boyfriend", "Girlfriend", "Partner",
    "Mom", "Dad", "Grandma", "Grandpa",
    "Niece", "Nephew", "Cousin", "Fiancé(e)",
    "Myself", "Someone else",
];
const REL_LEGACY = ["Sibling", "Grandparent", "Fiancé"];
const GENDER = {
    Wife: "female", Girlfriend: "female", Mom: "female", Daughter: "female",
    Grandma: "female", Granddaughter: "female",
    Sister: "female", Niece: "female",
    Husband: "male", Boyfriend: "male", Dad: "male", Son: "male",
    Grandpa: "male", Grandson: "male", Brother: "male", Nephew: "male",
    Myself: "self",
};
function genderFor(relationship) {
    var _a;
    return (_a = GENDER[relationship]) !== null && _a !== void 0 ? _a : "neutral";
}
function herHim(relationship) {
    const g = genderFor(relationship);
    return g === "female" ? "her" : g === "male" ? "him" : "them";
}
const SPOUSE = new Set([
    "Husband", "Wife", "Partner", "Boyfriend", "Girlfriend",
    "Fiancé(e)", "Fiancé",
]);
const SIBLING = new Set(["Sister", "Brother", "Sibling"]);
const PARENT = new Set(["Mom", "Dad"]);
const GRAND = new Set(["Grandma", "Grandpa", "Grandparent"]);
const KID = new Set([
    "Son", "Daughter", "Grandson", "Granddaughter", "Niece", "Nephew",
]);
const SIGN_PARENT = new Set(["Daughter", "Son"]);
const SIGN_GRANDPARENT = new Set(["Granddaughter", "Grandson"]);
const SIGN_AUNTUNCLE = new Set(["Niece", "Nephew"]);
const SIGN_DESCENDANT = new Set([
    "Mom", "Dad", "Grandma", "Grandpa", "Grandparent",
]);
const SIGN_SIBLING = new Set(["Sister", "Brother", "Sibling", "Cousin"]);
function signOffsFor(relationship, senderFirst) {
    const rel = relationship.trim();
    let group;
    if (SPOUSE.has(rel)) {
        group = ["All my love", "Yours, always", "Love you, always"];
    }
    else if (SIGN_PARENT.has(rel)) {
        group = ["Love, Mom", "Love, Dad", "Mom and Dad"];
    }
    else if (SIGN_GRANDPARENT.has(rel)) {
        group = ["Love, Grandma", "Love, Grandpa", "Grandma and Grandpa"];
    }
    else if (SIGN_AUNTUNCLE.has(rel)) {
        group = ["Love, Auntie", "Love, Uncle", "Your aunt and uncle"];
    }
    else if (SIGN_DESCENDANT.has(rel)) {
        group = ["Love always", "Your daughter", "Your son"];
    }
    else if (SIGN_SIBLING.has(rel)) {
        group = ["Love always", "Your sister", "Your brother"];
    }
    else if (rel === "Myself") {
        return [];
    }
    else {
        group = ["With love", "Love always", "Always"];
    }
    const first = senderFirst.trim();
    const out = first ? [`Love, ${first}`, ...group] : group;
    return Array.from(new Set(out)).slice(0, 4);
}
function callNameConfig(relationship) {
    const fixed = {
        Grandma: { title: "What do you call her?", sub: "Use what you’d naturally say to her.", quick: ["Grandma", "Nana", "Grammy", "Gran", "Nonna"], placeholder: "Or type your own" },
        Grandpa: { title: "What do you call him?", sub: "Use what you’d naturally say to him.", quick: ["Grandpa", "Papa", "Grandad", "Pops", "Pop-Pop"], placeholder: "Or type your own" },
        Mom: { title: "What do you call her?", sub: "Use what belongs in the song.", quick: ["Mom", "Mum", "Mama", "Mommy"], placeholder: "Or type your own" },
        Dad: { title: "What do you call him?", sub: "Use what belongs in the song.", quick: ["Dad", "Daddy", "Papa", "Pops"], placeholder: "Or type your own" },
    };
    if (fixed[relationship])
        return fixed[relationship];
    if (SPOUSE.has(relationship))
        return { title: `What do you call ${herHim(relationship)}?`, sub: "Usually a first name works best. A nickname is fine too.", quick: [], placeholder: "e.g. Claire, Em, Babe" };
    if (KID.has(relationship)) {
        const g = genderFor(relationship);
        const poss = g === "female" ? "her" : g === "male" ? "his" : "their";
        return { title: `What’s ${poss} name?`, sub: `Use the name you naturally say to ${herHim(relationship)}.`, quick: [], placeholder: "e.g. Emma" };
    }
    if (relationship === "Friend")
        return { title: "What do you call them?", sub: "First name or nickname — whatever feels natural.", quick: [], placeholder: "e.g. Jess, JJ" };
    if (SIBLING.has(relationship))
        return { title: "What do you call them?", sub: "The name or nickname that belongs in the song.", quick: [], placeholder: "e.g. Jake, Sis" };
    if (relationship === "Myself")
        return { title: "What should the song call you?", sub: "The name or nickname that feels most like you.", quick: [], placeholder: "e.g. Alex, AJ" };
    return { title: "What should the song call them?", sub: "Name, nickname or title — whatever feels natural.", quick: [], placeholder: "e.g. Coach, Uncle Rob, Sarah" };
}
function familyAlternatives(relationship) {
    switch (relationship) {
        case "Grandma": return ["Grandma", "Nana", "Grammy", "Gran"];
        case "Grandpa": return ["Grandpa", "Papa", "Grandad", "Pops"];
        case "Mom": return ["Mom", "Mum", "Mama"];
        case "Dad": return ["Dad", "Papa", "Pops"];
        default: return [];
    }
}
const FAMILY_WORDS = new Set([
    "mom", "mum", "mama", "mommy", "dad", "daddy", "papa", "pops",
    "grandma", "grandpa", "nana", "grammy", "gran", "grandad", "pop-pop", "nonna",
]);
function looksLikeFirstName(value) {
    const x = value.trim().toLowerCase();
    if (!x)
        return false;
    return /^[a-z][a-z'-]{2,}$/.test(x) && !FAMILY_WORDS.has(x);
}
const OCCASION_VALUE = {
    "Just Because": "just_because",
    "I Love You": "i_love_you",
    "Birthday": "birthday",
    "Anniversary": "anniversary",
    "Missing You": "missing_you",
    "Thank You": "thank_you",
    "Apology": "apology",
    "Wedding": "wedding",
    "Friendship": "friendship",
    "In Memory": "memorial",
    "Milestone": "milestone",
    "Proposal": "engagement",
    "Retirement": "retirement",
    "Graduation": "graduation",
};
const ALL_OCCASIONS = [
    "Just Because", "I Love You", "Birthday", "Anniversary", "Missing You",
    "Thank You", "Apology", "Wedding", "Friendship", "In Memory",
    "Milestone", "Proposal", "Retirement", "Graduation",
];
const OCC_OTHER_LABEL = "Something else…";
function occasionOrder(relationship) {
    const LEAD = ["Birthday", "Anniversary", "In Memory"];
    if (SPOUSE.has(relationship))
        return ["Anniversary", "Birthday", "In Memory", "I Love You", "Just Because", "Wedding", "Proposal"];
    if (PARENT.has(relationship))
        return [...LEAD, "Thank You", "Just Because", "Milestone", "Retirement"];
    if (GRAND.has(relationship))
        return [...LEAD, "Thank You", "Just Because", "Milestone"];
    if (KID.has(relationship))
        return [...LEAD, "Graduation", "Milestone", "Just Because", "Wedding"];
    if (relationship === "Friend" || SIBLING.has(relationship))
        return [...LEAD, "Friendship", "Thank You", "Just Because", "Milestone"];
    if (relationship === "Myself")
        return ["Just Because", "Milestone", "Birthday", "Graduation", "Retirement"];
    return [...LEAD, "Thank You", "Just Because", "Milestone"];
}
const STORY_SCREEN_COPY = {
    qualities: {
        title: "What makes them special?",
        sub: "Describe their character and the qualities you love most",
        hint: "For best results, please include 1\u20132 sentences.",
        label: "Their beautiful qualities",
        placeholder: "Are they patient, wise, funny, protective, encouraging? What makes them the incredible person they are?",
    },
    memories: {
        title: "Share your favorite memories",
        sub: "Share a favorite moment",
        hint: "For best results, please include 1\u20132 sentences.",
        label: "Special moments together",
        placeholder: "Share how you met, special years, inside jokes, or moments that made your relationship unique...",
    },
    message: {
        title: "A message from your heart",
        sub: "Add a short personal note",
        hint: "For best results, please include 1\u20132 sentences.",
        label: "Special message",
        placeholder: "What do you want them to know, feel, or remember?",
    },
};
function storyHasRealDetail(story, starters = []) {
    let v = story;
    for (const s of starters)
        v = v.split(s).join(" ");
    return v.replace(/[.…,;:!?\s]+/g, "").length >= 3;
}
const GENRE_VALUE = {
    Gospel: "gospel", Country: "country", Acoustic: "acoustic", Pop: "pop",
    "R&B": "rnb", Rock: "rock", Jazz: "jazz", Folk: "folk", Blues: "blues",
    Soul: "soul",
};
const MOOD_VALUE = {
    Heartfelt: "heartfelt", Romantic: "romantic", Joyful: "joyful",
    Sentimental: "sentimental", Uplifting: "uplifting", Playful: "playful",
    Peaceful: "peaceful", Reflective: "reflective", Hopeful: "hopeful",
};
const VOICE_VALUE = {
    "Female voice": "female", "Male voice": "male", "Surprise Me": "no_preference",
};
const ALL_STYLES = [
    "Gospel", "Country", "Acoustic", "Pop", "R&B", "Rock", "Jazz", "Folk",
    "Blues", "Soul",
];
const SURPRISE = "Surprise Me";
function recommendedStyles(relationship, occasionLabel) {
    if (occasionLabel === "In Memory")
        return ["Gospel", "Acoustic", "Soul", "Country"];
    if (PARENT.has(relationship) || GRAND.has(relationship))
        return ["Gospel", "Country", "Acoustic", "Soul"];
    if (SPOUSE.has(relationship))
        return ["Country", "Acoustic", "Pop", "R&B"];
    return ["Pop", "Acoustic", "Country", "Soul"];
}
function moodOptions(relationship, occasionLabel) {
    if (occasionLabel === "In Memory")
        return ["Peaceful", "Reflective", "Hopeful", "Sentimental"];
    if (SPOUSE.has(relationship))
        return ["Romantic", "Heartfelt", "Joyful", "Playful", "Sentimental"];
    if (KID.has(relationship))
        return ["Heartfelt", "Joyful", "Uplifting", "Playful"];
    return ["Heartfelt", "Joyful", "Sentimental", "Uplifting", "Reflective"];
}
function resolveSurpriseStyle(relationship, occasionLabel) {
    return recommendedStyles(relationship, occasionLabel)[0];
}
function resolveSurpriseMood(relationship, occasionLabel) {
    return moodOptions(relationship, occasionLabel)[0];
}
const SCREENS = [
    "relationship", "callname", "occasion",
    "sound",
    "traits", "memory",
];
function quizProgress(screen) {
    const total = SCREENS.length;
    const step = screen === "review" ? total + 1 : SCREENS.indexOf(screen) + 1;
    return { step: Math.min(step, total), total, percent: Math.round((step / (total + 1)) * 100) };
}
const PHASES = {
    relationship: { name: "About them", caption: "A few quick details", segments: [0.34, 0, 0, 0] },
    callname: { name: "About them", caption: "Make it personal", segments: [0.68, 0, 0, 0] },
    occasion: { name: "About them", caption: "One more thing", segments: [1, 0, 0, 0] },
    sound: { name: "The sound", caption: "Shape the music", segments: [1, 0.8, 0, 0] },
    traits: { name: "Their story", caption: "This makes the song theirs", segments: [1, 1, 0.5, 0] },
    memory: { name: "Their story", caption: "A moment worth singing about", segments: [1, 1, 1, 0] },
    review: { name: "Ready", caption: "One quick check", segments: [1, 1, 1, 0.94] },
};
function normalizeScreenParam(raw) {
    const first = Array.isArray(raw) ? raw[0] : raw;
    const n = Number.parseInt(first !== null && first !== void 0 ? first : "1", 10);
    if (!Number.isFinite(n) || n < 1)
        return 1;
    return Math.min(n, SCREENS.length);
}
const TRAITS_ROMANTIC = [
    "Loving", "Kind", "My best friend", "Makes me laugh", "Patient",
    "Generous", "Strong", "Always there", "Thoughtful", "Gentle", "Honest",
    "Supportive", "Warm", "My safe place",
    "Stubborn", "Terrible dancer", "Always cold", "Fixes everything",
    "Never lets me win", "Cries at films", "Can't sit still", "Best hugs",
    "Sings in the car", "Steals the covers", "Always hungry",
    "Makes the coffee", "Never on time", "Overpacks", "Talks to the dog",
    "Terrible at lying", "Plans everything", "Hopeless romantic",
    "Still holds my hand", "Bad at surprises", "Snores", "Remembers it all",
];
const TRAITS_PARENT = [
    "Loving", "Selfless", "Kind", "Hardworking", "Always there", "Strong",
    "Generous", "Wise", "Patient", "Proud of me", "Gentle", "Forgiving",
    "My biggest fan", "Devoted", "Stubborn", "Bad jokes", "Always early",
    "Lists for everything", "Same advice twice", "Sunday roast",
    "Always busy",
];
const TRAITS_PARENT_PAST = [
    "Fed everyone", "Never sat down", "Worried out loud",
    "Sang while cooking", "Kept my drawings", "Gave up everything",
    "Fixed everything", "Waited up", "Asked for nothing",
    "Made it from scratch", "Drove me everywhere", "Cried at everything",
    "Danced in the kitchen", "Called to check", "Never complained",
];
const TRAITS_GRAND = [
    "Loving", "Kind", "Wise", "Generous", "Gentle", "Full of stories",
    "Family's heart", "Proud of me", "Patient", "Devoted", "Warm",
    "Steady", "Comforting", "Same story twice", "So stubborn",
    "Always gardening", "Sharp as a tack", "Wicked humour",
    "Same old coat", "Best roast dinner", "Their own chair",
    "Sweets in the pocket",
];
const TRAITS_GRAND_PAST = [
    "Never judged", "Always had sweets", "Fixed everything",
    "Sang the old songs", "Fed everyone twice", "Called every Sunday",
    "Kept everything", "Kept every photo", "Never sat still",
    "Slipped me money", "Knew everyone", "Wrote real letters",
    "Danced at weddings", "Whistled always",
];
const TRAITS_KID = [
    "Kind", "Funny", "Brave", "Clever", "Loving", "Full of joy", "Gentle",
    "Determined", "Curious", "Generous", "Thoughtful", "Bright", "Caring",
    "Big heart",
    "Never stops talking", "Asks why forever", "Dances everywhere",
    "Stubborn", "Big feelings", "Friends with all", "Bad at losing",
    "An old soul", "Fearless", "Collects everything", "Draws on walls",
    "Sings made-up songs", "Hates bedtime", "Loves animals",
    "Tells long stories", "Copies everything", "Always muddy",
    "Runs everywhere", "Wants to help", "Laughs at nothing",
    "Never still", "Asks for one more",
];
const TRAITS_SIBLING = [
    "My best friend", "Funny", "Loyal", "Kind", "Has my back", "Generous",
    "Strong", "Talented", "Thoughtful", "Protective", "Honest", "Fun",
    "Supportive", "My first call",
    "Partner in crime", "Knows my secrets", "Stubborn", "Always right",
    "Steals my clothes", "Never texts back", "Competitive", "Total chaos",
    "Started every fight", "Covered for me", "Calls at odd hours",
    "Remembers it all", "A bad influence", "Always loudest",
    "Beat me at everything", "Steals my food", "Knows me too well",
    "Softer than they look", "Makes me cry laughing", "Copies my haircut",
    "Never lost a game", "Would fight for me",
];
const TRAITS_FRIEND = [
    "Loyal", "Funny", "Kind", "Generous", "Always there", "Genuine",
    "Big-hearted", "Easy to talk to", "Thoughtful", "Warm", "Honest", "Fun",
    "Dependable", "One in a million",
    "Always shows up", "Always late", "Brutally honest", "Answers at 3am",
    "Never judges", "Remembers it all", "Up for anything", "Feeds everyone",
    "Terrible dancer", "Loud", "Quietly steady", "Competitive",
    "Good bad influence", "Sends the memes", "First one there",
    "Last to leave", "Cries at films", "Best advice", "Plans nothing",
    "Terrible at goodbyes", "Knows me too well", "Never forgets a birthday",
];
const TRAITS_SELF = [
    "Kind", "Strong", "Loyal", "Funny", "Hopeful", "Honest", "Caring",
    "Determined", "Generous", "Patient", "Grateful", "Resilient", "Loving",
    "Enough",
    "Stubborn", "Still learning", "Restless", "Tired but trying",
    "A dreamer", "A fighter", "Soft-hearted", "Too honest", "Overthinks",
    "Never gives up", "Quiet", "Curious", "Bad at asking help",
    "Always planning", "Kinder than I was", "Learning to rest",
    "Hard on myself", "Getting there", "Says yes too often",
    "Better than I was", "Not finished yet", "Proud of myself",
];
const TRAITS_GENERAL = [
    "Kind", "Funny", "Generous", "Loving", "Loyal", "Patient", "Strong",
    "Big-hearted", "Thoughtful", "Gentle", "Honest", "Warm", "Genuine",
    "Selfless",
    "Stubborn", "Fearless", "Always early", "Feeds everyone",
    "Never sits still", "Brutally honest", "Quietly strong",
    "Wickedly funny", "Terrible dancer", "Remembers it all",
    "Never complains", "Fixes everything", "Tells long stories",
    "Up for anything", "Always busy", "Good in a crisis", "Sings badly",
    "Best advice", "Never forgets a birthday", "Makes everyone welcome",
    "Laughs at everything", "Bad at sitting down",
];
function traitsFor(relationship, occasionLabel) {
    const memorial = occasionLabel === "In Memory";
    if (SPOUSE.has(relationship))
        return TRAITS_ROMANTIC;
    if (PARENT.has(relationship))
        return memorial ? [...TRAITS_PARENT, ...TRAITS_PARENT_PAST] : TRAITS_PARENT;
    if (GRAND.has(relationship))
        return memorial ? [...TRAITS_GRAND, ...TRAITS_GRAND_PAST] : TRAITS_GRAND;
    if (KID.has(relationship))
        return TRAITS_KID;
    if (SIBLING.has(relationship))
        return TRAITS_SIBLING;
    if (relationship === "Friend")
        return TRAITS_FRIEND;
    if (relationship === "Myself")
        return TRAITS_SELF;
    return TRAITS_GENERAL;
}
const TRAITS_SCREEN = {
    title: "What are they like?",
    hint: "The small specific ones make the best lines.",
};
const STORY_PROMPTED_SCREEN = {
    title: "What should the song know?",
    sub: "Share what you remember \u2014 even one little detail can make their song feel deeply personal.",
    hint: "Every box here is optional.",
    elseLabel: "Something else",
    elsePlaceholder: "An inside joke, a place that matters, a line the song should say\u2026",
};
const STORY_SCREEN = {
    title: "Anything else the song should know?",
    sub: "A story, a favourite memory, an inside joke, something it must say.",
    hint: "Optional \u2014 but one real detail is what makes it theirs.",
    label: "In your own words",
    placeholder: "How you met, a moment you both remember, a phrase only they say, something you\u2019ve never told them\u2026",
};
function storyPlaceholder(relationship, occasionLabel) {
    if (occasionLabel === "In Memory")
        return "A memory that brings a smile, something they always said, what they meant to you\u2026";
    if (relationship === "Boyfriend" || relationship === "Girlfriend")
        return "How you met, the moment you started falling, what you love most about them\u2026";
    if (SPOUSE.has(relationship))
        return "How you met, a ritual only you two have, the moment you knew\u2026";
    if (PARENT.has(relationship))
        return "A memory from growing up, something they did you never forgot, the phrase they always say\u2026";
    if (GRAND.has(relationship))
        return "A memory from when you were small, what they taught you, something they always say\u2026";
    if (SIBLING.has(relationship))
        return "Growing up together, a story only you two laugh at, what makes them one of a kind\u2026";
    if (KID.has(relationship))
        return "Something they loved as a little kid, a moment you were proudest, what you hope they always remember\u2026";
    if (relationship === "Friend")
        return "How you became friends, a story only you two laugh at, what makes them one of a kind\u2026";
    if (relationship === "Myself")
        return "A chapter that mattered, what it took to get here, a line you live by\u2026";
    return STORY_SCREEN.placeholder;
}
const MEMORY_SCREEN = {
    title: "Share your favorite memories",
    sub: "Share a favorite moment",
    hint: "For best results, please include 1\u20132 sentences.",
    label: "Special moments together",
};
const MESSAGE_SCREEN = {
    title: "A message from your heart",
    sub: "Add a short personal note",
    hint: "For best results, please include 1\u20132 sentences.",
    label: "Special message",
};
function messagePlaceholder(relationship, occasionLabel) {
    if (occasionLabel === "In Memory")
        return "What you\u2019d tell them if you could, what you carry from them, what you never got to say\u2026";
    if (relationship === "Boyfriend" || relationship === "Girlfriend")
        return "What you love about them, what you hope is ahead, the thing you don\u2019t say often enough\u2026";
    if (SPOUSE.has(relationship))
        return "What you still love, what you\u2019d choose again, the thing you don\u2019t say often enough\u2026";
    if (PARENT.has(relationship))
        return "What you never quite said thank you for, what you hope they know\u2026";
    if (GRAND.has(relationship))
        return "What they gave you that stayed, what you want them to hear while you can say it\u2026";
    if (SIBLING.has(relationship))
        return "What they\u2019ve been to you, the thing you\u2019d never say to their face\u2026";
    if (KID.has(relationship))
        return "What you\u2019re proud of, what you hope they remember when things are hard\u2026";
    if (relationship === "Friend")
        return "What they\u2019ve been through with you, why they matter, what you\u2019ve never told them\u2026";
    if (relationship === "Myself")
        return "What you want to remember about now, what you\u2019d tell yourself, what you\u2019re still carrying\u2026";
    return "What you want them to know, feel, or remember\u2026";
}
function storyPrompts(relationship, occasionLabel, name) {
    const n = name.trim();
    const them = n || "them";
    const they = n || "they";
    const says = n ? `${n} always says` : "they always say";
    if (occasionLabel === "In Memory") {
        return [
            { key: "smile", question: "A memory that brings a smile", label: "A memory that brings a smile", placeholder: "The kitchen radio, the long drives, the garden\u2026" },
            { key: "said", question: `Something ${n ? `${n} always said` : "they always said"}`, label: "Something they always said", placeholder: "The phrase everyone still repeats\u2026" },
            { key: "meant", question: `What did ${they} mean to you?`, label: "What they meant to me", placeholder: "In your own words \u2014 a few are enough." },
        ];
    }
    const dating = relationship === "Boyfriend" || relationship === "Girlfriend";
    let base;
    if (SPOUSE.has(relationship)) {
        base = dating
            ? [
                { key: "met", question: "How did you two meet?", label: "How we met", placeholder: "A bus stop, a wedding, third-period math\u2026" },
                { key: "falling", question: "The moment you started falling", label: "When I started falling", placeholder: "The second coffee, the call that went long\u2026" },
                { key: "love", question: `What do you love most about ${them}?`, label: "What I love most", placeholder: "The laugh before the joke lands\u2026" },
            ]
            : [
                { key: "met", question: "How did you two meet?", label: "How we met", placeholder: "A bus stop, a wedding, third-period math\u2026" },
                { key: "ritual", question: "A little ritual only you two have", label: "A ritual only we have", placeholder: "Sunday coffee, the goodnight text, the song in the car\u2026" },
                { key: "love", question: `What do you love most about ${them}?`, label: "What I love most", placeholder: "The laugh before the joke lands\u2026" },
            ];
    }
    else if (PARENT.has(relationship)) {
        base = [
            { key: "growingup", question: "A memory from growing up", label: "A memory from growing up", placeholder: "Sunday pancakes, the kitchen radio, school mornings\u2026" },
            { key: "neverforgot", question: `Something ${they} did that you never forgot`, label: "What I never forgot", placeholder: "The extra shift, the all-night drive, never missing a game\u2026" },
            { key: "says", question: `Something ${says}`, label: "Something they always say", placeholder: "The phrase everyone teases them about\u2026" },
        ];
    }
    else if (GRAND.has(relationship)) {
        base = [
            { key: "small", question: "A memory from when you were small", label: "When I was small", placeholder: "The kitchen, the stories, the garden, the sweet tin\u2026" },
            { key: "taught", question: `What did ${they} teach you?`, label: "What they taught me", placeholder: "Patience, card games, the secret recipe\u2026" },
            { key: "says", question: `Something ${says}`, label: "Something they always say", placeholder: "The blessing, the warning, the joke\u2026" },
        ];
    }
    else if (SIBLING.has(relationship)) {
        base = [
            { key: "together", question: "A memory from growing up together", label: "Growing up together", placeholder: "The shared room, the fights, the cover-ups\u2026" },
            { key: "laugh", question: "A story only you two laugh at", label: "A story only we laugh at", placeholder: "The road trip, the wrong train\u2026" },
            { key: "onekind", question: `What makes ${them} one of a kind?`, label: "One of a kind because", placeholder: "Shows up before you ask\u2026" },
        ];
    }
    else if (KID.has(relationship)) {
        base = [
            { key: "littlekid", question: `Something ${them} loved as a little kid`, label: "As a little kid", placeholder: "Dinosaurs, the blue blanket, that one song\u2026" },
            { key: "proud", question: "A moment you were proudest", label: "A moment I was proudest", placeholder: "The recital, the first day, the comeback\u2026" },
            { key: "remember", question: `What do you hope ${they} always remember${n ? "s" : ""}?`, label: "What I hope they remember", placeholder: "That home is always here\u2026" },
        ];
    }
    else if (relationship === "Friend") {
        base = [
            { key: "became", question: "How did you become friends?", label: "How we became friends", placeholder: "College, the first job, next door\u2026" },
            { key: "laugh", question: "A story only you two laugh at", label: "A story only we laugh at", placeholder: "The road trip, the wrong train\u2026" },
            { key: "onekind", question: `What makes ${them} one of a kind?`, label: "One of a kind because", placeholder: "Shows up before you ask\u2026" },
        ];
    }
    else {
        base = [
            { key: "shared", question: "A memory you share", label: "A memory we share", placeholder: "A trip, a season, an ordinary day that stuck\u2026" },
            { key: "says", question: `Something ${says}`, label: "Something they always say", placeholder: "The phrase everyone knows them by\u2026" },
            { key: "onekind", question: `What makes ${them} one of a kind?`, label: "One of a kind because", placeholder: "In a few words\u2026" },
        ];
    }
    let extra = null;
    switch (occasionLabel) {
        case "Anniversary":
        case "Wedding":
        case "Proposal":
            extra = { key: "knew", question: "The moment you knew", label: "The moment I knew", placeholder: "When it stopped being a question\u2026" };
            break;
        case "Birthday":
            extra = { key: "year", question: `What made this year ${n ? `${n}\u2019s` : "theirs"}?`, label: "What this year held", placeholder: "The new job, the marathon, the move\u2026" };
            break;
        case "Thank You":
            extra = { key: "thanks", question: `What are you thanking ${them} for?`, label: "Thank you for", placeholder: "The thing they never made a fuss about\u2026" };
            break;
        case "Missing You":
            extra = { key: "miss", question: "What do you miss most?", label: "What I miss most", placeholder: "The everyday things count double\u2026" };
            break;
        case "Apology":
            extra = { key: "know", question: `What do you want ${them} to know?`, label: "What I want them to know", placeholder: "Say it plainly \u2014 the song will carry it." };
            break;
        case "Graduation":
        case "Milestone":
        case "Retirement":
            extra = { key: "took", question: "What did it take to get here?", label: "What it took", placeholder: "The night shifts, the second tries\u2026" };
            break;
        default:
            extra = null;
    }
    return extra ? [...base, extra] : base;
}
function sanitizeTraits(value) {
    const raw = Array.isArray(value) ? value : [];
    const seen = new Set();
    const out = [];
    for (const v of raw) {
        if (typeof v !== "string")
            continue;
        const t = v.trim().replace(/\s+/g, " ").slice(0, 60);
        if (!t)
            continue;
        const k = t.toLowerCase();
        if (seen.has(k))
            continue;
        seen.add(k);
        out.push(t);
        if (out.length >= 40)
            break;
    }
    return out;
}
const MEMORY_LABEL = "A memory they shared: ";
const MESSAGE_LABEL = "What they want the song to say: ";
const TRAITS_LABEL = "What they\u2019re like: ";
const PROMPT_SEP = ": ";
function assembleStory(parts) {
    var _a, _b;
    const out = [];
    const traits = ((_a = parts.traits) !== null && _a !== void 0 ? _a : []).map((t) => t.trim()).filter(Boolean);
    if (traits.length)
        out.push(`${TRAITS_LABEL}${traits.join(", ")}`);
    for (const p of (_b = parts.prompts) !== null && _b !== void 0 ? _b : []) {
        const value = p.value.trim();
        if (value)
            out.push(`${p.label}${PROMPT_SEP}${value}`);
    }
    const main = parts.story.trim();
    if (main)
        out.push(main);
    const memory = parts.memory.trim();
    if (memory)
        out.push(`${MEMORY_LABEL}${memory}`);
    const message = parts.message.trim();
    if (message)
        out.push(`${MESSAGE_LABEL}${message}`);
    const pron = parts.pronunciation.trim();
    if (pron) {
        const n = parts.name.trim() || "the name";
        out.push(`${n} is pronounced "${pron}" — spell it that way where it is sung if it helps the singer.`);
    }
    return out.join("\n\n");
}
function splitStory(column, promptSpec = []) {
    var _a, _b, _c, _d;
    const empty = {
        traits: [],
        prompts: {},
        story: "",
        memory: "",
        message: "",
        pronunciation: "",
    };
    const raw = (column !== null && column !== void 0 ? column : "").trim();
    if (!raw)
        return empty;
    const blocks = raw
        .split(/\n{2,}/)
        .map((b) => b.trim())
        .filter(Boolean);
    let pronunciation = "";
    const pronMatch = (_a = blocks[blocks.length - 1]) === null || _a === void 0 ? void 0 : _a.match(/ is pronounced "([^"]*)"/);
    if (pronMatch) {
        pronunciation = pronMatch[1].trim();
        blocks.pop();
    }
    let message = "";
    if ((_b = blocks[blocks.length - 1]) === null || _b === void 0 ? void 0 : _b.startsWith(MESSAGE_LABEL)) {
        message = blocks.pop().slice(MESSAGE_LABEL.length).trim();
    }
    let memory = "";
    if ((_c = blocks[blocks.length - 1]) === null || _c === void 0 ? void 0 : _c.startsWith(MEMORY_LABEL)) {
        memory = blocks.pop().slice(MEMORY_LABEL.length).trim();
    }
    let traits = [];
    if ((_d = blocks[0]) === null || _d === void 0 ? void 0 : _d.startsWith(TRAITS_LABEL)) {
        traits = sanitizeTraits(blocks.shift().slice(TRAITS_LABEL.length).split(","));
    }
    const prompts = {};
    while (blocks.length) {
        const head = blocks[0];
        const hit = promptSpec.find((p) => head.startsWith(p.label + PROMPT_SEP));
        if (!hit)
            break;
        prompts[hit.key] = blocks.shift().slice(hit.label.length + PROMPT_SEP.length).trim();
    }
    return { traits, prompts, story: blocks.join("\n\n"), memory, message, pronunciation };
}

function universalKidTraits() {
    return ["Kind", "Funny", "Loving", "Big heart", "Brave", "Strong", "Generous", "Thoughtful", "Caring", "Gentle", "Full of joy", "Makes me proud",
        "Beautiful soul", "My sunshine", "Still my baby", "My best friend", "Best hugs", "Determined", "Never gives up", "Curious", "Clever", "Creative",
        "Always helping others", "Hardworking", "Grew up too fast", "An old soul", "Fearless", "Stubborn", "Big feelings", "Friends with all", "Never stops talking",
        "Dances everywhere", "Loves animals", "Tells long stories", "Bad at losing", "Laughs at nothing", "Life of the party"];
}
function memoryExample(rel, occ) {
    const g = genderFor(rel), fem = g === "female", male = g === "male", P = fem ? "She" : male ? "He" : "They", obj = fem ? "her" : male ? "him" : "them";
    if (occ === "In Memory")
        return P + " whistled the same old song every morning. I still hear it when the kettle boils.";
    if (SPOUSE.has(rel)) {
        if (occ === "Anniversary")
            return fem ? "Forty years ago she said yes on her mother’s porch swing. She still sits there with me every evening."
                : male ? "Forty years ago he walked me home in the rain. He still holds the umbrella over me." : "Forty years ago we shared an umbrella on our first walk home. We still do.";
        if (occ === "Wedding" || occ === "Proposal")
            return "The first time I heard " + obj + " laugh, I knew I wanted to hear it for the rest of my life.";
        if (rel === "Husband")
            return "He still brings me coffee in bed every Sunday, after all these years.";
        if (rel === "Wife")
            return "We danced in the kitchen the night we got the keys to our first home.";
        return "We got lost on our first road trip, and it turned into the best day of the summer.";
    }
    if (KID.has(rel)) {
        if (occ === "Graduation")
            return P + " studied at the kitchen table every night and never once gave up.";
        if (occ === "Wedding")
            return fem ? "She walked around in my high heels when she was five. Now she’s walking down the aisle." : "He used to say he’d never get married. Then he met the one.";
        if (occ === "Milestone")
            return P + " just moved into " + (fem ? "her" : "his") + " first home, and still calls me to ask how long to cook the turkey.";
    }
    if (PARENT.has(rel)) {
        if (occ === "Retirement")
            return rel === "Dad" ? "He left for work at six every morning for forty years and still made it to every one of my games."
                : "She worked nights at the hospital for thirty years and never once missed a school play.";
        if (occ === "Thank You")
            return rel === "Dad" ? "He drove three hours every weekend to fix things at my first apartment, and never let me pay for gas."
                : "She drove three hours every weekend when the baby came, and never once complained.";
    }
    if (occ === "Retirement")
        return P + " kept the whole office laughing for twenty-five years. Nobody knows how we’ll manage without " + obj + ".";
    const M = {
        Daughter: "She carried her blue blanket everywhere. Now she’s a nurse, taking care of everyone else.",
        Son: "He took apart every toy to see how it worked. Now he fixes everything in our house.",
        Granddaughter: "Every summer we picked strawberries, and she ate more than she ever saved.",
        Grandson: "He used to fall asleep on my lap after Sunday dinner. Now he’s taller than me.",
        Niece: "She calls me every week just to tell me about her day.",
        Nephew: "He still calls me for advice before every big decision.",
        Mom: "She sang along to the radio every morning while she packed our lunches.",
        Dad: "He taught me to fish at the lake and never once complained about my tangled line.",
        Grandma: "Her Sunday pancakes, and the way she hummed while she made them.",
        Grandpa: "He let me steer the tractor and told everyone I was the best driver on the farm.",
        Sister: "We shared a bedroom for twelve years and still laugh at the same silly joke.",
        Brother: "We shared a bedroom for twelve years and still laugh at the same silly joke.",
        Friend: "We met at the school gate thirty years ago and have talked every week since.",
        Myself: "I went back to school at sixty and finished my degree."
    };
    return M[rel] || "The way they light up a room, and the song they always sing in the car.";
}
function fromChips(rel) {
    if (rel === "Daughter" || rel === "Son")
        return ["Mom", "Dad", "Mom and Dad"];
    if (rel === "Granddaughter" || rel === "Grandson")
        return ["Grandma", "Grandpa", "Grandma and Grandpa"];
    if (rel === "Niece" || rel === "Nephew")
        return ["Aunt", "Uncle", "Aunt and Uncle"];
    if (rel === "Mom" || rel === "Dad")
        return ["Daughter", "Son"];
    if (rel === "Grandma" || rel === "Grandpa")
        return ["Granddaughter", "Grandson"];
    return [];
}
function fromPlaceholder(rel) {
    if (rel === "Daughter" || rel === "Son")
        return "e.g. Mama, Stepmom, Papa";
    if (rel === "Granddaughter" || rel === "Grandson")
        return "e.g. Nana, Papa, Gigi";
    if (rel === "Niece" || rel === "Nephew")
        return "e.g. Auntie Jo, Uncle Rob";
    if (rel === "Grandma" || rel === "Grandpa")
        return "e.g. All the grandkids";
    return "e.g. Stepdaughter, all of us";
}

window.SBQ_ENGINE={QUIZ2_STORAGE_KEY,REL_CHIPS,REL_LEGACY,genderFor,herHim,SPOUSE,SIBLING,PARENT,KID,signOffsFor,callNameConfig,familyAlternatives,looksLikeFirstName,OCCASION_VALUE,ALL_OCCASIONS,OCC_OTHER_LABEL,occasionOrder,STORY_SCREEN_COPY,storyHasRealDetail,GENRE_VALUE,MOOD_VALUE,VOICE_VALUE,ALL_STYLES,SURPRISE,recommendedStyles,moodOptions,resolveSurpriseStyle,resolveSurpriseMood,SCREENS,quizProgress,PHASES,normalizeScreenParam,traitsFor,TRAITS_SCREEN,STORY_PROMPTED_SCREEN,STORY_SCREEN,storyPlaceholder,MEMORY_SCREEN,MESSAGE_SCREEN,messagePlaceholder,storyPrompts,sanitizeTraits,MEMORY_LABEL,MESSAGE_LABEL,TRAITS_LABEL,PROMPT_SEP,assembleStory,splitStory,universalKidTraits,memoryExample,fromChips,fromPlaceholder};
})();
